/*global Daon*/
/*eslint no-undef: "error"*/

const actionPrefix = "DOCUMENT_CAPTURE_";

export const SELECT_DOC_TYPE = actionPrefix + "SELECT_DOC_TYPE";
export const PREVIEW = actionPrefix + "PREVIEW";
export const RETRY = actionPrefix + "RETRY";
export const RESET_RETRIES = actionPrefix + "RESET_RETRIES";
export const SET_CROPPED_IMAGE = actionPrefix + "SET_CROPPED_IMAGE";
export const CREATE_INSTANCE = actionPrefix + "CREATE_INSTANCE";
export const FIRST_TIME_INIT = actionPrefix + "FIRST_TIME_INIT";
export const RETRY_PROCESSING = actionPrefix + "RETRY_PROCESSING";
export const IS_SINGLE_PAGED = actionPrefix + "IS_SINGLE_PAGED";
export const SET_DOCUMENT_QUALITY_RETRIES =
  actionPrefix + "SET_DOCUMENT_QUALITY_RETRIES";
export const RETRY_DOCUMENT_QUALITY = actionPrefix + "RETRY_DOCUMENT_QUALITY";
export const RESET_ALL_RETRIES_FAILED =
  actionPrefix + "RESET_ALL_RETRIES_FAILED";
export const RESETING_DOCUMENT_QUALITY_RETRIES =
  actionPrefix + "RESETING_DOCUMENT_QUALITY_RETRIES";
export const COUNTRY_SELECTOR = actionPrefix + "COUNTRY_SELECTOR";
export const CAMERA_CHANGED = actionPrefix + "CAMERA_CHANGED";
export const MODAL_SHOWED = actionPrefix + "MODAL_SHOWED";
export const DOCUMENT_CAPTURE_CONFIG = actionPrefix + "DOCUMENT_CAPTURE_CONFIG";
export const CAMERA_RESOLUTION = actionPrefix + "CAMERA_RESOLUTION";
export const COUNTRY_NUM = actionPrefix + "COUNTRY_NUM";

export function selectDocumentType(payload) {
  return { type: SELECT_DOC_TYPE, payload };
}

export function preview(payload) {
  return { type: PREVIEW, payload };
}

export function retry(payload) {
  return { type: RETRY, payload };
}

export function retryProcessing(payload) {
  return { type: RETRY_PROCESSING, payload };
}

export function resetRetries() {
  return { type: RESET_RETRIES };
}

export function setCroppedImage(payload) {
  return { type: SET_CROPPED_IMAGE, payload };
}

export function setDocumentQualityRetries(payload) {
  return { type: SET_DOCUMENT_QUALITY_RETRIES, payload };
}

export function retryDocumentQuality(payload) {
  return { type: RETRY_DOCUMENT_QUALITY, payload };
}

export function createInstance(config) {
  return {
    type: CREATE_INSTANCE,
    payload: new Daon.DocumentCapture(config),
  };
}

export function resetAllRetriesFailed(payload) {
  return {
    type: RESET_ALL_RETRIES_FAILED,
  };
}

export function documentCaptureConfig(payload) {
  return {
    type: DOCUMENT_CAPTURE_CONFIG,
    payload: {
      numOfFrames: payload.numOfFrames,
      initialCaptureDelay: payload.initialCaptureDelay,
      captureInterval: payload.captureInterval,
      timeout: payload.timeout,
    },
  };
}

export function cameraResolution(payload) {
  return {
    type: CAMERA_RESOLUTION,
    payload: {
      width: payload.width,
      height: payload.height,
    },
  };
}

export function countrySelected(payload) {
  return {
    type: COUNTRY_NUM,
    payload,
  };
}

export function firstTimeInit() {
  return {
    type: FIRST_TIME_INIT,
  };
}

export function modalShowed() {
  return {
    type: MODAL_SHOWED,
  };
}

export function changeCamera(payload) {
  return {
    type: CAMERA_CHANGED,
    payload,
  };
}

export function isSinglePaged(payload) {
  return { type: IS_SINGLE_PAGED, payload };
}

export function resetingDocumentQualityRetries(payload) {
  return {
    type: RESETING_DOCUMENT_QUALITY_RETRIES,
    payload,
  };
}
export function countrySelector(payload) {
  return {
    type: COUNTRY_SELECTOR,
    payload,
  };
}
